import React from "react"
import { Col, Form, Input } from "antd"
import { blurInputOnWeel } from "Shared/utils/helpers"
import { FormInputElementInterface, FormInputTypes } from "./form.types"

interface FormInputInterface {
    elem: FormInputElementInterface
    span?: number
    inputType: FormInputTypes
}

export default function FormInputElem({ elem, inputType, span = 12 }: FormInputInterface) {
    return (
        <Col span={span}>
            <Form.Item label={elem.label} name={elem.name} style={{ marginBottom: "0px" }} initialValue={elem.initialValue} rules={elem.rules}>
                <Input type={inputType} placeholder={elem.placeholder} onChange={elem.onChange} onWheel={blurInputOnWeel} />
            </Form.Item>
        </Col>
    )
}
